export default __webpack_public_path__ + "static/media/yo_3.5b9a33e5.mp3";